<template>
    <div>
        <limitless-page-header :loading="busy_loading" :title="'Bildbank'" :sub-title="category_name" :title-id="category_id">
            <template #header-elements>
                <limitless-page-header-button :route="{ name: 'mediabank.categories' }" icon="icon-circle-left2">Tillbaka</limitless-page-header-button>
            </template>
        </limitless-page-header>

        <div class="content">
            <tb-skeleton v-if="busy_loading" :height="100" :theme="'opacity'" :shape="'radius'" bg-color="#dcdbdc"></tb-skeleton>

            <div v-else-if="!busy_loading && category">
                <div class="row">
                    <div class="col-lg-6">
                        <div class="card">
                            <div class="card-body">
                                <ValidationObserver ref="categoryform">
                                    <form @submit.prevent="saveCategory">
                                        <div class="row">
                                            <div class="col-lg-12">
                                                <input-with-validation
                                                    vid="CatName"
                                                    label="Namn"
                                                    rules="required"
                                                    v-model="category.CatName"
                                                ></input-with-validation>
                                            </div>
                                        </div>
                                    </form>
                                </ValidationObserver>
                            </div>
                            <div class="card-footer">
                                <div class="d-flex justify-content-end">
                                    <limitless-button v-if="category.CatID > 0" ref="btndeletecategory" type="button" @click="deleteCategory" :busy="busy_saving" icon="icon-cross2" btn-class="btn-danger" class="mr-auto">Radera</limitless-button>
                                    <limitless-button ref="btnsavecategory" type="button" @click="saveCategory" :busy="busy_saving" icon="icon-floppy-disk">Spara</limitless-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div> <!-- /content -->
    </div>
</template>

<script>
import apiClient from '@services/ApiClient';
import LimitlessPageHeader from '@components/Layout/partials/LimitlessPageHeader';
import LimitlessPageHeaderButton from '@components/Layout/partials/LimitlessPageHeaderButton';
import LimitlessButton from '@components/Limitless/LimitlessButton';
import getError from '@services/ErrorHelper';
import InputWithValidation from '@components/Form/InputWithValidation.vue';

export default {
    name: 'MediabankCategoryEdit',
    components: {
        InputWithValidation,
        LimitlessButton,
        LimitlessPageHeader,
        LimitlessPageHeaderButton,
    },
    props: {
        id: {
            type: [Number, String],
            default: 0,
        },
    },
    data: () => ({
        busy_loading: true,
        busy_saving: false,
        busy_translating: false,
        category: null,
        languages: [],
    }),
    mounted() {
        this.getCategory();
    },
    methods: {
        getCategory() {
            this.busy_loading = true;
            apiClient.get('/vue/mediabank/categories/' + this.id + '')
                .then((response) => {
                    this.category = response.data;
                })
                .finally(() => {
                    this.busy_loading = false;
                });
        },
        async saveCategory() {
            const isValid = await this.$refs.categoryform.validate();
            if (isValid) {
                this.busy_saving = true;
                await apiClient.post('/vue/mediabank/categories/' + this.id, this.category)
                    .then((response) => {
                        if (parseInt(this.id, 10) !== parseInt(response.data.CatID, 10)) {
                            window.location.href = '/mediabank/categories/' + response.data.CatID;
                        }
                        this.category = response.data;
                        this.$refs.btnsavecategory.triggerSaved();
                    })
                    .catch((error) => {
                        const parsederror = getError(error);
                        if (typeof parsederror === 'object') {
                            this.$refs.categoryform.setErrors(parsederror);
                        }
                        this.$refs.btnsavecategory.triggerFailed();
                    })
                    .finally(() => {
                        this.busy_saving = false;
                    });
            }
        },
        async deleteCategory() {
            let doChange = false;
            await this.$swal({
                text: 'Är du säker att du vill radera denna kategori?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Ja, ta bort!',
                cancelButtonText: 'Avbryt',
            }).then((result) => {
                if (result.isConfirmed) {
                    doChange = true;
                }
            });
            if (doChange) {
                this.busy_saving = true;
                apiClient.delete('/vue/mediabank/categories/' + this.id)
                    .then(() => {
                        this.$router.push({ name: 'mediabank.categories' });
                        this.busy_saving = false;
                    })
                    .catch(() => {
                        this.$refs.btndeletecategory.triggerFailed();
                    })
                    .finally(() => {
                        this.busy_saving = false;
                    });
            }
        },
    },
    computed: {
        category_name() {
            return (this.category && this.category.CatID > 0 ? this.category.CatName : 'Ny kategori');
        },
        category_id() {
            return (this.category && this.category.CatID > 0 ? this.category.CatID : '');
        },
    },
};

</script>
